import { Injectable } from '@angular/core';
import jwtDecode from 'jwt-decode';
import { JWTPayload } from '../interfaces/jwtPayload';

@Injectable({
  providedIn: 'root',
})
export class JwtService {
  public decode(token: string): JWTPayload {
    try {
      return jwtDecode(token) as JWTPayload;
    } catch (err) {
      throw new Error('Failed to decode token');
    }
  }
}
